import React from 'react'
import { STRING, ICONS, QUERY_PARAMS } from '../../../utils/Constant'
import { checkImage, checkForBlank } from '../../../utils/commonUtility'
import Tooltip from '@material-ui/core/Tooltip';

const GlobalSearch = ({ globalPageHandler, globalSearchData, tableMaxValue, handledKey,
    searchMoreHandler, searchTabHandler, getBtnValue, Btn2Val, btnDropDown }) => (
        <div className="global-search-main container-fluid">
            <button className="btn mr-15px pull-left" onClick={e => globalPageHandler(e, false)}>
                <i className="fa fa-chevron-left" />
                <span>&nbsp;&nbsp;Back</span>
            </button>
            <div className="global-search-result">
                <span className="global-search-for"> Search for: </span>
                <hr />
                <button className={"kog-btn mr-15px"} onClick={e => searchTabHandler(QUERY_PARAMS.COMPANIES, STRING.COMPANIES)}>
                    <i className={"fa " + (ICONS.COMPANIES)} />
                                &nbsp;&nbsp;<div className="float-right">{STRING.COMPANIES}</div>
                </button>
                <div className="relative d-inline-block">
                    <button className={"kog-btn mr-15px"} onClick={e => getBtnValue(e)}>
                        <i className={"fa " + (ICONS.SECTOR)} />
                                    &nbsp;&nbsp;<div className="float-right">{Btn2Val}</div>
                    </button>
                    {btnDropDown ?
                        <ul className="tab-dd">
                            <li className={Btn2Val === STRING.SECTORS ? 'kognetics-actice-class' : ''} onClick={e => searchTabHandler(QUERY_PARAMS.SECTOR, STRING.SECTORS)}>{STRING.SECTORS}</li>
                            <li className={Btn2Val === STRING.INDUSTRIES ? 'kognetics-actice-class' : ''} onClick={e => searchTabHandler(QUERY_PARAMS.INDUSTRY, STRING.INDUSTRIES)}>{STRING.INDUSTRIES}</li>
                            <li className={Btn2Val === STRING.SUB_INDUSTRIES ? 'kognetics-actice-class' : ''} onClick={e => searchTabHandler(QUERY_PARAMS.SUB_INDUSTRY, STRING.SUB_INDUSTRIES)}>{STRING.SUB_INDUSTRIES}</li>
                        </ul>
                        : null}
                </div>
                <button className={"kog-btn mr-15px"} onClick={e => searchTabHandler(QUERY_PARAMS.INVESTOR, STRING.INVESTORS)}>
                    <i className={"fa " + (ICONS.INVESTOR)} />
                                &nbsp;&nbsp;<div className="float-right">{STRING.INVESTORS}</div>
                </button>
                <button className={"kog-btn mr-15px"} onClick={e => searchTabHandler(QUERY_PARAMS.FUNDING_ROUND, STRING.FUNDING_ROUNDS)}>
                    <i className={"fa " + (ICONS.FUNDING_ROUND)} />
                                &nbsp;&nbsp;<div className="float-right">{STRING.FUNDING_ROUNDS}</div>
                </button>
                <button className={"kog-btn mr-15px"} onClick={e => searchTabHandler(QUERY_PARAMS.ACQUISITIONS, STRING.ACQUISITIONS)}>
                    <i className={"fa " + (ICONS.ACQUISITIONS)} />
                                &nbsp;&nbsp;<div className="float-right">{STRING.ACQUISITIONS}</div>
                </button>
                <button className={"kog-btn mr-15px"} onClick={e => searchTabHandler(QUERY_PARAMS.DEAL_IDEAS, STRING.DEAL_IDEAS)}>
                    <i className={"fa " + (ICONS.INSIGHTS)} />
                                &nbsp;&nbsp;<div className="float-right">{STRING.DEAL_IDEAS}</div>
                </button>
                <hr />
                <div className="result-values">
                    {Object.keys(globalSearchData).length > 0 ?
                        Object.keys(globalSearchData).map((key, i) => {
                            return (
                                <React.Fragment key={i}>
                                    {globalSearchData[key].length > 0 ?
                                        <>
                                            <div className="global-search-heading">
                                                <i
                                                    className={"fa " + (key === 'company' ?
                                                        ICONS.COMPANIES
                                                        : key === 'investor' ?
                                                            ICONS.INVESTOR
                                                            : ICONS.SECTOR
                                                    )}
                                                />
                                    &nbsp;&nbsp;{key}
                                            </div>
                                            <ul className="global-search-result-list">
                                                {globalSearchData[key].length > 0 ?
                                                    globalSearchData[key].slice(0, handledKey !== '' ?
                                                        handledKey === key ?
                                                            tableMaxValue
                                                            : 3
                                                        : 3).map((results, j) => {
                                                            return (
                                                                <li key={j}>
                                                                    <span>
                                                                        <div className="entity-img-div">
                                                                            {checkImage(window['runTimeData'].LOGO_BASE_URL + results.Permalink + window['runTimeData'].LOGO_EXTENSION) ?
                                                                                <img className="img-responsive entity-img" src={window['runTimeData'].LOGO_BASE_URL + results.Permalink + window['runTimeData'].LOGO_EXTENSION} alt="" />
                                                                                :
                                                                                <i
                                                                                    className={"fa entity-img " + (key === 'company' ?
                                                                                        ICONS.COMPANIES
                                                                                        : key === 'investor' ?
                                                                                            ICONS.INVESTOR
                                                                                            : ICONS.SECTOR
                                                                                    )}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    </span>
                                                                    <span>&nbsp;&nbsp;</span>
                                                                    {/* {key !== 'investor' ? */}
                                                                    <a
                                                                        href={
                                                                            key === 'company' ?
                                                                                "/companyProfile/Company/" + results.Name
                                                                                :
                                                                                key === 'investor' ?
                                                                                    "/investorProfile/Investor/" + results.Name
                                                                                    :
                                                                                    key === 'sector' ?
                                                                                        "/profile/Sector/" + results.Name
                                                                                        :
                                                                                        key === 'industry' ?
                                                                                            "/profile/Industry/" + results.Name
                                                                                            :
                                                                                            "/profile/Sub-Industry/" + results.Name
                                                                        }
                                                                        className="result-name">
                                                                        {checkForBlank(results.Name) ? results.Name : null}
                                                                    </a>
                                                                    {/* :
                                                                        <span className="result-name">
                                                                            {checkForBlank(results.Name) ? results.Name : null}
                                                                        </span>
                                                                    } */}
                                                                    {checkForBlank(results.LongDescription) ?
                                                                        <Tooltip title={results.LongDescription} placement="bottom" arrow>
                                                                            <span className="result-description">
                                                                                <>&nbsp;{results.LongDescription}</>
                                                                            </span>
                                                                        </Tooltip>
                                                                        : null}
                                                                </li>
                                                            )
                                                        })
                                                    : null}
                                                {globalSearchData[key].length > 3 ?
                                                    <li className="show-more">
                                                        {/* {handledKey !== '' ? */}
                                                        {tableMaxValue === 3 ?
                                                            <b
                                                                className="pointer"
                                                                onClick={e => searchMoreHandler(e, 'more', key)}
                                                            >
                                                                {"SHOW MORE"}
                                                            </b>
                                                            :
                                                            <b
                                                                className="pointer"
                                                                onClick={handledKey !== '' ?
                                                                    handledKey === key ?
                                                                        e => searchMoreHandler(e, "less", key)
                                                                        : e => searchMoreHandler(e, "more", key)
                                                                    : e => searchMoreHandler(e, "more", key)}
                                                            >
                                                                {handledKey !== '' ?
                                                                    handledKey === key ?
                                                                        "SHOW LESS"
                                                                        : "SHOW LESS"
                                                                    : "SHOW MORE"}
                                                            </b>
                                                        }
                                                    </li>
                                                    : null}
                                            </ul>
                                        </>
                                        : null}
                                </React.Fragment>
                            )
                        })
                        :
                        <div className="no-result-global">
                            <i className="fa fa-search" />
                            <p>Initiate Your Search</p>
                        </div>
                    }
                </div>
            </div>
        </div >
    )

export default GlobalSearch;